'use client';
import { useOptions } from '@/lib/api/common/options.queries';
import OptionFilterList from './OptionFilterList';
import SidebarSection from './SidebarSection';

const LevelComponent = () => {
  const { data: skillLevelOptions } = useOptions({ gkey: 'position_level' });

  return (
    <SidebarSection title="Мэргэжлийн түвшин">
      <OptionFilterList options={skillLevelOptions} paramName="level" />
    </SidebarSection>
  );
};

export default LevelComponent;
